import { useEffect } from "react";
import moment from "moment";

// https://stackoverflow.com/questions/23074748/important-inline-styles-in-react
export const vipStyle = (n, style) => {
  if (n) {
    for (const s in style) {
      n.style.setProperty(s, style[s], "important");
    }
  }
};

export const useOutsideClickDetection = (ref, onClickOutside) => {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside();
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
};

const maxSeoTextLength = 60;
export const getSeoText = (text) => {
  // Retirement Income One? -> requirement-income-one
  // Remove special chars
  // Replace space by dash
  // Convert to lower case
  let clean = text
    .replace(/[^\w\s]/gi, "")
    .replace(/ /g, "-")
    .toLowerCase();

  // Cut by max length
  // Cut by last exceeding word
  const words = clean.split("-");
  let result = "";

  let splitter = "";
  for (const word of words) {
    if ((result + splitter + word).length <= maxSeoTextLength) {
      result += splitter + word;
    } else {
      break;
    }
    splitter = "-";
  }
  return result.trim();
};
// let data = getSeoText("I am 55 years old but have not decided what to do with my CPF savings. Can I take out only when I need it?")
// console.log(data, data.length);

const PASSPORT_MIN_LENGTH = 4;
const PASSPORT_MAX_LENGTH = 15;
export const isValidPassport = (v) => {
  return v.length >= PASSPORT_MIN_LENGTH && v.length <= PASSPORT_MAX_LENGTH;
};

export const isValidCpfAccountNumber = (v) => {
  const re = /^[S,T][A,B,C,D,F]\d{6}[A-Z]$/i;
  return re.test(v);
};

export const isValidEmail = (v) => {
  // const re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  const re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  return re.test(v);
};

const OTP_LENGTH = 6;
export const isValidOTP = (v) => {
  if(!v) return false;
  return v.length === OTP_LENGTH;
};

// ref -> safe string
export const safeVal = (ref) => ref.current ? ref.current.value.trim() : "";

export const generateYearWithNRIC = (nric) => {
  // this function work only for the people born in 1968 and after
  // first character S and T for Sg , F and G for foreigner
  // first two digit of nric reflect to last two digits of birth year.
  // But it only applies to Singapore citizens and PRs born in the year 1968 and after.
  // For those born before 1968, their NRIC number will begin with a 0 or 1
  if (nric.length === 9) {
    //https://sg.theasianparent.com/singapore-nric-number-surprising-facts
    let prefix = nric.substring(0, 1);
    // f

    let year = nric.substring(1, 3);

    if (!parseInt(year)) {
      // Nan
      return ["E"];
    }

    let first_year = parseInt(nric.substring(1, 3), 10);

    console.log(prefix, year);
    if (prefix === "S") {
      // citizen born before 2000

      let current_year = new Date().getFullYear();

      if (first_year < 68) {
        // people born before 1968

        return ["S", current_year - 1968, ">"];
      } else {
        let birth_year = parseInt("19" + year, 10);
        const _age = current_year - birth_year;
        return ["S", _age, _age === 0 ? "<" : "="];
      }
    } else if (prefix === "T") {
      // citizen born after 2020
      let current_year = new Date().getFullYear();
      console.log(current_year);

      let birth_year = parseInt("20" + year, 10);
      console.log(birth_year);
      const _age = current_year - birth_year;
      return ["S", _age, _age === 0 ? "<" : "="];
    } else {
      return ["E"]; // F & G
    }
  } else {
    return ["E"];
  }
};

const MIN_PASSPORT_LENGTH = 4;

export const isValidNric = (str) => {
  if (str.length != 9) return false;

  str = str.toUpperCase();

  var i,
    icArray = [];
  for (i = 0; i < 9; i++) {
    icArray[i] = str.charAt(i);
  }

  icArray[1] = parseInt(icArray[1], 10) * 2;
  icArray[2] = parseInt(icArray[2], 10) * 7;
  icArray[3] = parseInt(icArray[3], 10) * 6;
  icArray[4] = parseInt(icArray[4], 10) * 5;
  icArray[5] = parseInt(icArray[5], 10) * 4;
  icArray[6] = parseInt(icArray[6], 10) * 3;
  icArray[7] = parseInt(icArray[7], 10) * 2;

  var weight = 0;
  for (i = 1; i < 8; i++) {
    weight += icArray[i];
  }

  var offset = icArray[0] === "T" || icArray[0] === "G" ? 4 : 0;
  var offset = icArray[0] === "M" ? 3 : offset;
  var temp = (offset + weight) % 11;

  var st = ["J", "Z", "I", "H", "G", "F", "E", "D", "C", "B", "A"];
  var fg = ["X", "W", "U", "T", "R", "Q", "P", "N", "M", "L", "K"];
  var m = ["K", "L", "J", "N", "P", "Q", "R", "T", "U", "W", "X"];

  var theAlpha;
  if (icArray[0] === "S" || icArray[0] === "T") {
    theAlpha = st[temp];
  } else if (icArray[0] === "F" || icArray[0] === "G") {
    theAlpha = fg[temp];
  } else if (icArray[0] === "M") {
    const mIndex = 10 - temp;
    theAlpha = m[mIndex];
  }

  return icArray[8] === theAlpha;
};

export const validatePassportAndNRIC = (val) => {
  const _val = val.trim().toUpperCase();

  const match = _val.match(/^[S|T|F|G|M][0-9]{7}[A-Z]$/gm);
  if (match === null && _val.length >= MIN_PASSPORT_LENGTH) {
    // Passport
    return true;
  }
  if (match !== null) {
    return validateNRIC(val);
  }
};

export const isValidMobileNumber = (mobile) => {
  if (!mobile) {
    return false;
  }
  return mobile.match(/^[9|8][0-9]{7}$/gm) ? true : false;
};

export const maskMobileNumber = (mobile) => {
  if (!isValidMobileNumber(mobile)) {
    return mobile;
  }
  return `${mobile[0]}*****${mobile.slice(-2)}`;
};

// https://stackoverflow.com/questions/39247866/mask-email-in-javascript
export const maskEmailAddress = (email) => {
  if (!isValidEmail(email)) {
    return email;
  }
  return email.replace(/^(.)(.*)(.@.*)$/,
       (_, a, b, c) => a + b.replace(/./g, '*') + c
  );
};

// YYYYMMDDHHmmss
export const getExpAtDiffSec = (expAt) => {
  return moment(expAt, "YYYYMMDDHHmmss").diff(moment(), "seconds");
}
